import { LANDING_TYPES } from '@landing/components/ProductResults/constants'
import { getPercent } from '@recommendation/helpers'

export function attraqtToHighlightedProductCardProps(
  {
    displayTitle,
    images: [imageSrc],
    link,
    listing: { price, warranty },
    referencePrice,
    subTitles,
  } = {
    images: [],
    listing: { price: {} },
    referencePrice: {},
    subTitles: [],
  },
  { attributes } = {},
) {
  return {
    attributes,
    description: subTitles.join(' - '),
    imageAlt: displayTitle,
    imageSrc,
    link,
    percentageDifference: getPercent(price.amount, referencePrice.amount),
    price,
    title: displayTitle,
    warranty,
  }
}

export function algoliaToHighlightedProductCardProps(
  {
    currency,
    image1,
    link_grade_v2,
    merchant_link_grade_v2,
    price_new,
    price,
    sub_title_elements,
    title_model,
    warranty,
  } = {
    sub_title_elements: [],
  },
  { attributes, landingType, month } = {},
) {
  return {
    attributes,
    description: sub_title_elements.join(' - '),
    imageAlt: title_model,
    imageSrc: image1,
    link:
      landingType === LANDING_TYPES.SELLER
        ? merchant_link_grade_v2
        : link_grade_v2,
    percentageDifference: getPercent(price, price_new),
    price: {
      amount: price,
      currency,
    },
    title: title_model,
    warranty: `${warranty} ${month}`,
  }
}

export function attraqtToProductCardProps(
  {
    listing: { id, price, grade, warranty },
    link,
    displayTitle,
    referencePrice,
    subTitles,
    images,
    title,
  } = {
    listing: {},
  },
  { attributes, priceFormatter } = {
    priceFormatter: (val) => val,
  },
) {
  return {
    id,
    attributes,
    grade: grade?.name,
    link,
    originalPrice: {
      raw: referencePrice?.amount,
      display: priceFormatter(referencePrice),
    },
    price: {
      raw: price?.amount,
      display: priceFormatter(price),
    },
    subTitleModel: subTitles,
    thumbnail: Array.isArray(images) ? images[0] : undefined,
    title: displayTitle,
    titleModel: title,
    warranty,
  }
}

export function algoliaToProductCardProps(
  {
    backbox_grade_label,
    image1,
    link_grade_v2,
    merchant_link_grade_v2,
    objectID,
    price_new_with_currency,
    price_new,
    price_with_currency,
    price,
    sub_title_elements,
    title_model,
    warranty,
    title,
  } = {},
  { attributes, landingType, month } = {},
) {
  return {
    id: objectID,
    attributes,
    grade: backbox_grade_label,
    link:
      landingType === LANDING_TYPES.SELLER
        ? merchant_link_grade_v2
        : link_grade_v2,
    originalPrice: {
      raw: price_new,
      display: price_new_with_currency,
    },
    price: {
      raw: price,
      display: price_with_currency,
    },
    subTitleModel: sub_title_elements,
    thumbnail: image1,
    title,
    titleModel: title_model,
    warranty: `${warranty} ${month}`,
  }
}
